import { ref } from "vue";

/**
 * Composable for managing series action choice dialog state
 * Handles the choice between editing series vs instance
 */
export function useSeriesActionState() {
	const state = ref({
		show: false,
		action: '', // 'edit' or 'delete'
		booking: null,
	});

	const pendingDragData = ref(null);

	const showSeriesChoiceDialog = (action, booking) => {
		state.value = {
			show: true,
			action,
			booking,
		};
	};

	const closeSeriesChoiceDialog = () => {
		state.value = {
			show: false,
			action: '',
			booking: null,
		};
		pendingDragData.value = null;
	};

	const setPendingDragData = (dragData) => {
		pendingDragData.value = dragData;
	};

	const getPendingDragData = () => {
		return pendingDragData.value;
	};

	const clearPendingDragData = () => {
		pendingDragData.value = null;
	};

	const showEditSeriesChoice = (booking) => {
		showSeriesChoiceDialog('edit', booking);
	};

	const showDeleteSeriesChoice = (booking) => {
		showSeriesChoiceDialog('delete', booking);
	};

	return {
		// State
		seriesChoiceState: state,
		
		// Drag data management
		setPendingDragData,
		getPendingDragData,
		clearPendingDragData,

		// Actions
		showSeriesChoiceDialog,
		closeSeriesChoiceDialog,
		showEditSeriesChoice,
		showDeleteSeriesChoice,
	};
}